import { createRoot } from "react-dom/client";

import { queryOrThrow } from "@rootreeweb/js-lib";

import { App } from "./app/App.js";

const container = queryOrThrow<HTMLDivElement>("#rt-impact-report-container");
declare global {
	interface Window {
		rtImpactReport: Record<string, string>;
	}
}

createRoot(container).render(<App translations={window.rtImpactReport} />);
